/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { getIn, useFormikContext } from "formik";
import { pagingAdministrativeUnit } from "app/services/AdministrativeUnitService";
import { observer } from "mobx-react";
import { withNameSpace } from "app/common/LocalFunction";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import { pagingAdministrativeUnitPublic } from "app/services/PublicService";

function PatientAddress({ nameSpace, disabledForm, requiredFields = {} }) {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();
  const isPublic = window.location.pathname.includes("public");

  const handleChangeCurrent = (level, value) => {
    switch (level) {
      case 1:
        setFieldValue(withNameSpace("currentProvince", nameSpace), value);
        setFieldValue(withNameSpace("currentDistrict", nameSpace), null);
        setFieldValue(withNameSpace("currentWard", nameSpace), null);

        break;
      case 2:
        setFieldValue(withNameSpace("currentDistrict", nameSpace), value);
        setFieldValue(
          withNameSpace("currentProvince", nameSpace),
          value?.parent
        );
        setFieldValue(withNameSpace("currentWard", nameSpace), null);
        break;
      case 3:
        setFieldValue(
          withNameSpace("currentDistrict", nameSpace),
          value.parent
        );
        setFieldValue(
          withNameSpace("currentProvince", nameSpace),
          value?.parent?.parent
        );
        setFieldValue(withNameSpace("currentWard", nameSpace), value);
        break;
      default:
        break;
    }
  };

  return (
    <>
        <>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <GlobitsPagingAutocomplete
              name={withNameSpace("currentAddress", nameSpace)}
              api={
                isPublic ? pagingAdministrativeUnitPublic : pagingAdministrativeUnit
              }
              label={t("patient.address")}
              searchObject={{ level: null }}
              getOptionLabel={(option) => option?.detailsAddress?.toUpperCase()}
              filterOptions={(x) => x}
              onChange={(e, value, action) => {
                if (action === "clear") {
                  setFieldValue(withNameSpace("currentAddress", nameSpace), null);

                  return;
                }
                setFieldValue(withNameSpace("currentAddress", nameSpace), value);
                handleChangeCurrent(value.level, value);
              }}
              disabled={disabledForm}
              autoUpercase
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <GlobitsPagingAutocomplete
              label={t("province")}
              name={withNameSpace("currentProvince", nameSpace)}
              required={requiredFields?.["currentProvince"] === true}
              api={
                isPublic ? pagingAdministrativeUnitPublic : pagingAdministrativeUnit
              }
              searchObject={{ level: 1 }}
              filterOptions={(x) => x}
              onChange={(_, value, action) => {
                if (action === "clear") {
                  setFieldValue(withNameSpace("currentDistrict", nameSpace), null);
                  setFieldValue(withNameSpace("currentProvince", nameSpace), null);
                  setFieldValue(withNameSpace("currentWard", nameSpace), null);
                  setFieldValue(withNameSpace("currentAddress", nameSpace), null);
                  return;
                }
                handleChangeCurrent(value.level, value);
                setFieldValue(withNameSpace("currentAddress", nameSpace), value);
              }}
              tabIndex={-1}
              disabled={disabledForm}
              autoUpercase
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <GlobitsPagingAutocomplete
              label={t("district")}
              name={withNameSpace("currentDistrict", nameSpace)}
              required={requiredFields?.["currentDistrict"] === true}
              api={
                isPublic ? pagingAdministrativeUnitPublic : pagingAdministrativeUnit
              }
              searchObject={{
                level: 2,
                parentId: getIn(values, withNameSpace("currentProvince", nameSpace))
                  ?.id,
              }}
              filterOptions={(x) => x}
              onChange={(_, value, action) => {
                if (action === "clear") {
                  setFieldValue(withNameSpace("currentDistrict", nameSpace), null);
                  setFieldValue(withNameSpace("currentWard", nameSpace), null);
                  const currentProvince = getIn(
                    values,
                    withNameSpace("currentProvince", nameSpace)
                  );
                  setFieldValue(withNameSpace("currentAddress", nameSpace), {
                    ...currentProvince,
                    detailsAddress: `${currentProvince?.name}`,
                  });
                  return;
                }
                handleChangeCurrent(value.level, value);
                setFieldValue(withNameSpace("currentAddress", nameSpace), value);
              }}
              tabIndex={-1}
              disabled={disabledForm}
              autoUpercase
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={2}>
            <GlobitsPagingAutocomplete
              label={t("ward")}
              name={withNameSpace("currentWard", nameSpace)}
              required={requiredFields?.["currentWard"] === true}
              api={
                isPublic ? pagingAdministrativeUnitPublic : pagingAdministrativeUnit
              }
              searchObject={{
                level: 3,
                parentId: getIn(values, withNameSpace("currentDistrict", nameSpace))
                  ?.id,
              }}
              filterOptions={(x) => x}
              onChange={(_, value, action) => {
                if (action === "clear") {
                  console.log(
                    "district",
                    getIn(values, withNameSpace("currentDistrict", nameSpace))
                  );

                  setFieldValue(withNameSpace("currentWard", nameSpace), null);

                  const currentDistrict = getIn(
                    values,
                    withNameSpace("currentDistrict", nameSpace)
                  );
                  setFieldValue(withNameSpace("currentAddress", nameSpace), {
                    ...currentDistrict,
                    detailsAddress: `${currentDistrict?.name},${currentDistrict?.parent?.name}`,
                  });
                  return;
                }
                handleChangeCurrent(value.level, value);
                setFieldValue(withNameSpace("currentAddress", nameSpace), value);
              }}
              tabIndex={-1}
              disabled={disabledForm}
              autoUpercase
            />
          </Grid>
        </>

      <Grid item xs={12} sm={6} md={4} lg={2}>
        <GlobitsTextField
          label={t("street")}
          name={withNameSpace("currentDetailResidence", nameSpace)}
          disabled={disabledForm}
          autoUpercase
          required={requiredFields?.["currentDetailResidence"] === true}
        />
      </Grid>
    </>
  );
}

export default memo(observer(PatientAddress));
